import { Component, Element, Fragment, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-footer',
  styleUrl: 'cradlepoint-footer.css',
  shadow: true,
})
export class CradlepointFooter {
  @Element() el: HTMLElement;

  @Prop() json            : string;
  @Prop() logo            : string = 'https://img.cradlepoint.com/auto-mapping-folder/2022/04/cradlepoint-ericsson-logo-footer-378x70-1.png';
  @Prop() backgroundImage : string = 'https://img.cradlepoint.com/auto-mapping-folder/2020/04/footbg.webp';

  loaded          = false;
  hotline         = null;
  socialMedia     = null;
  nav             = null;
  mapSection      = null;
  copyright       = null;
  isEricssonTheme = false;


  async componentWillLoad() {
    if (this.json) {
      return fetch(this.json)
        .then(response => response.json())
        .then(data => {
          this.isEricssonTheme = document.body.classList.contains('ericsson-theme');
          // console.log(data);
          this.hotline = data.hot_line;
          this.socialMedia = data.social_media;
          this.nav = data.link_columns.columns;
          this.mapSection = data.map_section;
          this.copyright = data.copyright;
          this.loaded = true;
        })
        .catch(error => console.log(error));
    }

    return null;
  }

  render() {
    return (
      <Host
        class={ this.loaded ? 'loaded' : '' }
        style={{
          backgroundImage: this.isEricssonTheme ? 'none' : `url(${this.backgroundImage})`,
          backgroundColor: 'var(--cwc-footer-bg-color)'
        }}
      >
        <div class="container">
          <div class="inner-container row row-1">
            {this.loaded && (<Fragment>
              <div class="row-1__home-link-contact">
                <a class="row-1__home-link" href='/'>
                  {this.isEricssonTheme
                    ? <p>Ericsson Cradlepoint</p>
                    : (
                      this.logo && <img src={this.logo} alt="CradlePoint Logo" />
                    )
                  }
                </a>
                {this.hotline && (
                  <a href="tel:1-855-813-3385" class="row-1__contact-wrapper">
                    <cradlepoint-fontawesome-svg class="row-1__phone-icon" size="32px" color="white" icon="phone-volume"></cradlepoint-fontawesome-svg>
                    <h5
                      class="row-1__title font-bold color-white uppercase"
                      innerHTML={`${this.hotline.label} <span>${this.hotline.phone_no}</span>`}
                    ></h5>
                  </a>
                )}
                {this.socialMedia && (
                  <ul class="row-1__social-media">
                    {this.socialMedia.map((socialMediaItem: { link: { url: string; }; item: any; }) => {
                      return (
                        <a
                          href={socialMediaItem.link.url}
                          title={`Cradlepoint ${socialMediaItem.item}`}
                          target="_blank"
                          class={`cs cs-${socialMediaItem.item}`}
                          style={{color: 'white'}}
                        >
                          <cradlepoint-fontawesome-svg
                            icon={socialMediaItem.item}
                            color="white"
                            size="32px"
                          ></cradlepoint-fontawesome-svg>
                        </a>
                      )
                    })}
                  </ul>
                )}
              </div>
              <div class="row-1__linkgroups">
                {this.nav && this.nav.map((column2Item) => {
                  return (
                    <div>
                      <h4 class="row-1__linkgroup-title" innerHTML={column2Item.module[0].title}></h4>
                      {column2Item.module[1].list && (
                        <ul class="row-1__linkgroup">
                          {column2Item.module[1].list.map((column2ItemListItem: { link: { url: string; title: any; }; }) => {
                            return (
                              <li>
                                <a href={column2ItemListItem.link.url} target="_self">
                                  {column2ItemListItem.link.title}
                                </a>
                              </li>
                            )
                          })}
                        </ul>
                      )}
                    </div>
                  )
                })}
              </div>
            </Fragment>)}
          </div>
          <div class="inner-container row row-2">
            {this.mapSection && (
              <div class="row-2__location">
                <img
                  src={this.mapSection.image}
                  width="125"
                  height="64"
                  class="lazy row-2__map"
                  alt="Map"
                />
                <div class="row-2__address">
                  <h6 class="font-bold">{this.mapSection.label}</h6>
                  <address>{this.mapSection.address}</address>
                </div>
                {this.mapSection.branches && (
                  <div class="row-2__branches">
                    {this.mapSection.branches.map((branch: { link: { url: string; title: string; }; }) => {
                      return (
                        <a
                          class="font-bold"
                          href={branch.link.url}
                          title={branch.link.title}>{branch.link.title}
                        </a>
                      )
                    })}
                  </div>
                )}
              </div>
            )}
            {this.socialMedia && (
              <ul class="row-2__social-media">
                {this.socialMedia.map((socialMediaItem: { link: { url: string; }; item: any; }) => {
                  return (
                    <a
                      href={socialMediaItem.link.url}
                      title={`Cradlepoint ${socialMediaItem.item}`}
                      target="_blank"
                      class={`cs cs-${socialMediaItem.item}`}
                      style={{color: 'white'}}
                    >
                      <cradlepoint-fontawesome-svg
                        icon={socialMediaItem.item}
                        color="white"
                        size="32px"
                      ></cradlepoint-fontawesome-svg>
                    </a>
                  )
                })}
              </ul>
            )}
            {this.copyright && <div class="row-2__copyright" innerHTML={this.copyright.replace('{year}', new Date().getFullYear())}></div>}
          </div>
          {this.copyright && <div class="row-3__copyright" innerHTML={this.copyright.replace('{year}', new Date().getFullYear())}></div>}
        </div>
      </Host>
    );
  }

}
